import { render, staticRenderFns } from "./RollUpReport.vue?vue&type=template&id=6ff70258&scoped=true"
import script from "./RollUpReport.vue?vue&type=script&lang=js"
export * from "./RollUpReport.vue?vue&type=script&lang=js"
import style0 from "./RollUpReport.vue?vue&type=style&index=0&id=6ff70258&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff70258",
  null
  
)

export default component.exports